
import axios from 'axios'
import { parse, format, endOfMonth,isBefore, parseISO,addDays, eachDayOfInterval } from 'date-fns';
import { tr } from "date-fns/locale";

import { roomTypes, paxTypes, cities,stars } from '~/data/constants'
import en from '~/locale/en';
let icons = {"turTFlight": "fa-plane-departure", "turTBus": "fa-bus", "turTTrain": "fa-train", "turTShip": "fa-ship", "turTCar": "fa-car", "turTHotel": "fa-hotel", "turTFlightBus": "fa-plane-bus", "turTFlightTrain": "fa-plane-train", "turTFlightShip": "fa-plane-ship", "turTFlightCar": "fa-plane-car", "turTHotelBus": "fa-hotel-bus", "turTHotelTrain": "fa-hotel-train", "turTHotelShip": "fa-hotel-ship", "turTHotelCar": "fa-hotel-car"};
       
const getCityName = (id,lang) => { 
  let city = cities.find(item=> item.id == id);
  if(city && city.name){
    return city.name[lang] || city.name["tr"];
  }
  return ""; 
}

const getStarName = (id,lang) => {

  let star = stars.find(item=> item.id == id);
  if(star && star.name){
    return star.name[lang] || star.name["tr"];
  }
  return ""; 

}
const tourStatuses = [
  {
    value: "OPEN",
    title: {
      tr: "Müsait",
      en: "Available"
    },
    description: {
      tr: "Turda yeterli yer mevcut, rezervasyon yapılabilir.",
      en: "There are enough places available on the tour. Reservation can be made."
    },
    color: "green",
    available: true
  },
  {
    value: "NEW",
    title: {
      tr: "Yeni Açıldı",
      en: "Newly Available"
    },
    description: {
      tr: "Tur rezervasyona yeni açıldı.",
      en: "This tour has just opened for reservations."
    },
    color: "sky",
    available: true
  },
  {
    value: "GUARANTEED",
    title: {
      tr: "Kesin Hareketli",
      en: "Guaranteed Departure"
    },
    description: {
      tr: "Turun hareketi kesinleşmiştir, rezervasyon yapılabilir.",
      en: "This departure is guaranteed and available for reservation."
    },
    color: "green",
    available: true
  },
  {
    value: "HIGH_DEMAND",
    title: {
      tr: "Talep Görüyor",
      en: "In High Demand"
    },
    description: {
      tr: "Bu tur yoğun ilgi görüyor, erken rezervasyon yapmanız önerilir.",
      en: "This tour is in high demand. Early reservation is recommended."
    },
    color: "orange",
    available: true
  },
  {
    value: "FILLING_FAST",
    title: {
      tr: "Hızla Doluyor",
      en: "Filling Fast"
    },
    description: {
      tr: "Kontenjan hızla doluyor, yerinizi ayırtmak için gecikmeyin.",
      en: "Availability is filling fast. Book soon to secure your place."
    },
    color: "orange",
    available: true
  },
  {
    value: "LIMITED", 
    title: {
      tr: "Sınırlı Yer",
      en: "Limited Place"
    },
    description: {
      tr: "Turda sınırlı sayıda yer kaldı, hızlı rezervasyon yapmanız önerilir.",
      en: "Limited number of places left on the tour. It is recommended to make a quick reservation."
    },
    color: "yellow",
    available: true
  },
  {
    value: "LAST_SEATS",
    title: {
      tr: "Son Koltuklar",
      en: "Last Seats"
    },
    description: {
      tr: "Turda son koltuklar kaldı, hemen rezervasyon yapın.",
      en: "Only the last seats remain. Book now."
    },
    color: "red",
    available: true
  },
  {
    value: "LAST10", 
    title: {
      tr: "Son 10 Koltuk",
      en: "Last 10 Seats"
    },
    description: {
      tr: "Turda sadece 10 koltuk kaldı, acele edin.",
      en: "Only 10 seats are left on the tour. Book now."
    },
    color: "orange",
    available: true
  },
  ...[9, 8, 7, 6].map((seatCount) => ({
    value: `LAST${seatCount}`,
    title: {
      tr: `Son ${seatCount} Koltuk`,
      en: `Last ${seatCount} Seats`
    },
    description: {
      tr: `Turda sadece ${seatCount} koltuk kaldı, hemen rezervasyon yapın.`,
      en: `Only ${seatCount} seats are left on the tour. Book now.`
    },
    color: "red",
    available: true
  })),
  {
    value: "LAST5",
    title: {
      tr: "Son 5 Koltuk",
      en: "Last 5 Seats"
    },
     description: {
      tr: "Turda sadece 5 koltuk kaldı, hemen rezervasyon yapın.",
      en: "Only 5 seats are left on the tour. Book now."
     },
    color: "red",
    available: true
  },
  {
      value: "LAST4",
      title: {
        tr: "Son 4 Koltuk",
        en: "Last 4 Seats"
      },
      description: {
          tr: "Turda sadece 4 koltuk kaldı, hemen rezervasyon yapın.",
          en: "Only 4 seats are left on the tour. Book now."
      },
      color: "red",
      available: true
    },
    {
      value: "LAST3",
      title: {
        tr: "Son 3 Koltuk",
        en: "Last 3 Seats"
      },
       description: {
          tr: "Turda sadece 3 koltuk kaldı, hemen rezervasyon yapın.",
          en: "Only 3 seats are left on the tour. Book now."
       },
      color: "red",
      available: true
    },
    {
      value: "LAST2",
      title: {
        tr: "Son 2 Koltuk",
        en: "Last 2 Seats"
      },
      description: {
        tr: "Turda sadece 2 koltuk kaldı, hemen rezervasyon yapın.",
        en: "Only 2 seats are left on the tour. Book now."
     },
      color: "red",
      available: true
    }, {
      value: "LAST1",
      title: {
        tr: "Son 1 Koltuk",
        en: "Last Seat"
      },
      description: {
        tr: "Turda sadece 1 koltuk kaldı, hemen rezervasyon yapın.",
        en: "Only 1 seat is left on the tour. Book now."
     },
      color: "red",
      available: true
    },
  {
    value: "ASK", 
    title: {
      tr: "Bilgi Al",
      en: "Ask for availability"
    },
     description: {
        tr: "Yer durumu için lütfen bilgi alınız.",
        en: "Please ask for availability."
     },
    color: "indigo",
    available: true
  },
  
  {
    value: "FULL", 
    title: {
      tr: "Dolu",
      en: "Full"
    },
    description: {
      tr:  "Tur dolu, yeni rezervasyon alınamıyor.",
      en: "The tour is full, no new reservations can be made."
    },
    color: "red",
    available: false 
  },
  {
    value: "CLOSED", 
    title: {
      tr: "Kapalı",
      en: "Closed"
    },
    
    description: {
      tr:  "Tur kapalı, yeni rezervasyon alınamıyor.",
      en: "The tour is closed, no new reservations can be made."
    },
    color: "red",
    available: false
  },
   {
    value: "OFFER", 
    title: {
      tr: "Teklif",
      en: "Offer"
    },
    
    description: {
      tr:  "Tur kapalı, yeni rezervasyon alınamıyor.",
      en: "The tour is closed, no new reservations can be made."
    },
    color: "slate",
    available: false
  },
];
export function useTours() {
 
  const getTourDetail = (payload) => {
    const config = useRuntimeConfig();
 
    let id = payload.id;
    let slang = payload.lang;
    return new Promise((resolve, reject) => {
      axios({
        url: `${config.public.apiBase}`+"/graphql/direct",
        method: 'post',
        timeout: 15000,
        data: {
          query: `
              {
                tourDetail(pdb_Id:"`+ id + `") {
                  turd_Name {  tr }
                  turd_Detail{tr}
                  turd_Visa{tr}
                  turd_PriceInfo{tr}
                  turd_Galeri
                  turd_Highlight
                  turd_Icons
                }
              } 
              `
        }
      }).then(response => {
        // console.log(response.data)
        // console.log(topContentId)
        let donen = {};

        let icons = response.data.data.tourDetail[0]?.turd_Icons?.split("---");
        
        let retValue = response.data.data.tourDetail[0];
        
        // retValue.icons = icons.forEach(item=>{
        //   return item.
        // })
        resolve(retValue)


      }).catch(e => {
        // console.log(e)
        resolve(e)
        console.log(e)
      })
    })
  };
  
  const getTours = (payload,locale) => {
   
    let order = payload.order || 'turs_StartDate ASC,turf_Airway ASC,tur_Sure ASC,turs_double ASC';
    let slang = locale ? locale?.value ? locale?.value : locale :  payload.lang || "tr";
    let category = payload.category || '5YILDIZUMRE';
    // console.log("payload",payload);
    
    let minD = null;
    let maxD = 0;
    let excludeId = "";

    if(payload.excludeId){
      excludeId = payload.excludeId;
    }
    if(payload.duration && payload.duration.length>0){
      payload.duration.forEach(duration=>{
        let d = duration.split("-");
        if(d[1]){
          let s = parseInt(d[0]);
          let e = parseInt(d[1]);
          minD =  minD==null || minD > s ? s : minD
          maxD =  maxD < e ? e : maxD
        }
      }) 
    }else{
      minD = payload.minD || 0;
      maxD = payload.maxD || 100;
    }
    
    
    let startLeast = null;
    let endLeast = null;
    let hotelId = '';
    
    if(payload.activeHotelId && payload.activeHotelId!= null && payload.activeHotelId!= 'all' && payload.activeHotelId!= 'null' && payload.activeHotelId != undefined){ 
      hotelId = payload.activeHotelId;
    }
    if(payload.when && payload.when.length>0){
      payload.when.forEach(date=>{
        // console.log("date",date)
        // console.log("payload.when",payload.when)
        const parsedDate = parse('01-' + date, 'dd-MM-yy', new Date());
      
        let ds = format(parsedDate, 'yyyy-MM-dd');
        const endOfMonthDate = endOfMonth(parsedDate);
        let es = format(endOfMonthDate, 'yyyy-MM-dd');
 

        // Parse the date strings to Date objects
        const dsDate = parse(ds, 'yyyy-MM-dd', new Date());
        const esDate = parse(es, 'yyyy-MM-dd', new Date());
   
        const startLeastDate = parse(ds, 'yyyy-MM-dd', new Date());
        const endLeastDate = parse(es, 'yyyy-MM-dd', new Date());
 
        startLeast = startLeast==null || isBefore(dsDate, startLeastDate) ?  ds : startLeast;
        endLeast =   endLeast==null || isBefore(esDate, endLeastDate) ?  es : endLeast; ;
      }) 
    }else{
      startLeast = payload.startLeast || format(new Date(),"yyyy-MM-dd");
      const futureDate = addDays(new Date(), 270); 
      endLeast = payload.endLeast || format(futureDate, 'yyyy-MM-dd');;
    }

  
  
    let search = payload.search || 'eyJtb250aHMiOnt9LCJob3RlbFN0YXIiOnt9LCJob3RlbHMiOnt9LCJkdXJhdGlvbiI6e30sInByb3BlcnRpZXMiOnt9LCJhaXJ3YXlzIjp7fSwicGFnZSI6MX0';
    let limit = payload.limit || 50;
    let addMore = payload.addMore ? true : false;
    let page = payload.page || 0;
    let offset = typeof payload.offset == "number" ? payload.offset : 0;

    if (addMore) {
      let loadingMore = true;
    } else {
      let loading = true;
    }

    if (page > 1) {
      offset = limit * (page - 1)
      if (typeof offset != "number") {
        offset = 0;
      }
    }
    // console.log(payload);
    if (category && category != "") { } else {
      category = "5YILDIZUMRE";
    }



    let q = `
            {
            tours( 
                order:"`+ order + `",
                category:"` + category + `",
                excludeId:"` + excludeId + `",
                startLeast: "` + startLeast + `", 
                startMost: "` + endLeast + `", 
                sureMost: "`+ maxD + `", 
                sureLeast: "`+ minD + `",  
                hotel: "`+ hotelId + `",  
                limit: ` + limit + `,
                pdb_status: ` + 1 + `,
                offset: ` + offset + `,
                language: "` + slang + `",
                search: "` + search + `"
            ) { 
                pdb_Id
                turs_StartDate
                turs_EndDate
                tour_Currency 
                end
                start
                endDay
                startDay
                endMonth
                colorful_title{ en,tr }
                startMonth
                tur_Sure
                turd_Color
                turs_KotaRest
                photo
                turs_Detail
                topphoto
                turs_gallery
                turs_CampaignTitle{ en,tr }
                turd_Short { en,tr }
                airwayLogo
                airwayName { en,tr }
                destination
                detail{
                  turd_Name {  tr,en }
                  turd_Detail{tr}
                  turd_PriceInfo{tr}
                  turd_Galeri
                  turd_Highlight
                  turd_Icons
                }
                cityDuration,
                hotels {
                    turo_Sure
                    sOtelAdi {
                       tr,en
                    }
                    sOtelShort {
                      tr,en
                    }
                    star {
                      tr,en
                    }
                    city{
                        tr,en
                    }
                    hPhotoGallery
                    sOtelPhoto
                    hotelId 
                    sOtel_Konum
                }
                otel1{
                  city{ en,tr },
                  sOtelAdi{ en,tr },
                  sOtelShort{tr},
                  star{ en,tr }
                  sOtel_Konum
                }
                otel2{
                  city{ en,tr },
                  sOtelAdi{ en,tr },
                  sOtelShort{ en,tr },
                  star{ en,tr }
                }
                otel1_adi{ en,tr },
                otel1_city{ en,tr },
                otel1_photo,
                otel1_star{ en,tr },
                otel2_adi{ en,tr },
                otel2_city{ en,tr },
                otel2_photo,
                otel2_star{ en,tr },
                turs_otel1_sure,
                turs_otel2_sure,
                prices {
                    turf_Price
                    turf_RoomType
                    turf_PaxType
                    turf_MinAge
                    turf_MaxAge
                    pax{   en,tr  }
                    room{  en,tr  }
                },
                
                turs_status_data{
                    value
                    title
                    description
                    color
                    available
                }
                turs_double,
                turs_child,
                turs_baby,
                turs_single,
                turs_triple,
                turs_double_high,
                turs_child_high,
                turs_baby_high,
                turs_single_high,
                turs_triple_high,
                categories
                turs_program
                turs_title
                turs_price_info
                turs_voice_file
                turs_voice_video
                turs_show_video_or_sound
                guides {
                  id
                  name
                  photo
                  description
                }
                routes {
                  turs_Date
                  rDayName
                  turs_Transporter
                  turs_CityEnd {
                    tr
                    en
                  }
                  turs_CityStart {
                    tr
                    en
                  }
                  rYear
                  rDay
                  rMonth
                  turs_FlightNo
                  turs_Time
                  turs_transDetail {
                    tr
                    en
                  } 
                  flight_kuyruk_no
                  source_time
                }
            }
            }
        `;
        const config = useRuntimeConfig();
    // console.log(q)
    return new Promise((resolve, reject) => {
      axios({
        url: `${config.public.apiBase}`+"/graphql/direct",
        method: 'post',
        timeout: 15000,
        data: {
          query: q
        }
      }).then(response => {
     
       let tours = response.data.data.tours.map(item=>{

            const statusDefinition = tourStatuses.find(status => status.value === item.turs_status_data?.value) || tourStatuses[0];
            item.turs_status_data = {
              ...statusDefinition,
              title: statusDefinition.title?.[slang] || statusDefinition.title?.tr || '',
              description: statusDefinition.description?.[slang] || statusDefinition.description?.tr || ''
            };


            item.routes = item.routes.map(item => {    
              item.rDayName = formatDate(item.turs_Date, "EEEE",slang);
              item.rYear = formatDate(item.turs_Date, "yyyy",slang);
              item.turs_Transporter = icons[item.turs_Transporter] || item.turs_Transporter;
              item.rDay = formatDate(item.turs_Date, "dd",slang);
              item.rMonth = formatDate(item.turs_Date, "MMM",slang);
              item.turs_Date = formatDate(item.turs_Date,null,slang);
              item.turs_CityStart_Name = getCityName(item.turs_CityStart)
              item.turs_CityEnd_Name = getCityName(item.turs_CityEnd) ;

              return item;  

            }).sort((a, b) => {
              return a.pdb_sira - b.pdb_sira;
            });

            return item
       }) 

        resolve(tours);
      }).catch(e => {
        console.log(e)
        reject(e)
      })
    })

  }


      
  const  decodeHTMLEntities = (text,data)=>{
    var entities = {
      'amp': '&',
      'apos': '\'',
      'lt': '<',
      'gt': '>',
      'quot': '"',
      'nbsp': '\xa0',
      '&Ouml;': 'Ö',
      '&cc': 'g',
    };
    var entityPattern = /&([a-z]+);/ig;
     
      if(text && typeof text == "string"){
          // A single replace pass with a static RegExp is faster than a loop
          return text.replace(entityPattern, function(match, entity) {
            entity = entity.toLowerCase();
            if (entities.hasOwnProperty(entity)) {
              return entities[entity];
            }
            // return original string if there is no matching entity (no replace)
            return match;
          });
      }
    return text;
  }
  const getTourx = (payload, locale) => {
 
    let id = payload.id;
    let slang = locale || "tr";
    let q = `
     {
        tour(id: "`+ id + `") { 
            pdb_Id
            turs_StartDate
            turs_EndDate
            tour_Currency,
            end
            start
            endDay
            startDay
            endMonth
            startMonth
            tur_Sure
            colorful_title{ en,tr }
            turd_Color
            turs_KotaRest
            turs_Detail
            turs_Video
            turs_VideoPhoto
            photo 
            topphoto
            turs_gallery
            turs_double
            turs_double_high,
            turs_child_high,
            turs_baby_high,
            turs_single_high,
            turs_triple_high,
            destination
            categories
            turs_voice_text
            turs_voice_video
            turs_voice_file
            turs_show_video_or_sound
              turs_program
                turs_title
                turs_price_info
            turs_status_data{
                    value
                    title
                    description
                    color
                    available
           }
            detail{
                  turd_Name {  tr,en }
                  turd_Detail{tr}
                  turd_Visa{tr}
                  turd_PriceInfo{tr}
                  turd_Galeri
                  turd_Highlight
                  turd_Icons
                }
                  cityDuration,
                             turs_triple
                             turs_single
                             turs_child
                             turs_baby
                             turs_otel1
                             turs_otel1_sure
                             turs_otel2
                             turs_otel2_sure
 
                             otel1_star{
                               tr, en
                             }
                             otel2_star{
                               tr,en
                             }
                           otel1_city{
                               tr,en
                             }
                           otel2_city{
                               tr,
                               en
                             }
                           otel1_adi{
                               tr,
                               en
                             }
                           otel2_adi{
                               tr,
                               en
                             }
                             otel1_photo
                             otel2_photo
                             otel1_video
                             otel2_video
                             otel1_video_photo
                             otel2_video_photo
                             otel1_konum
                             otel2_konum
            turs_CampaignTitle{  tr, en   }
            turd_Short {  tr, en   }
            airwayLogo
            airwayName {  tr, en   }
            hotels {
              turo_Sure
              sOtelShort {
                tr
                en
              }
              sOtelAdi {
                tr
                en
              }
              star {
                tr
                en
              }
              city{
                  tr
                  en
              }
              
              hPhotoGallery
              sOtelPhoto
              hotelVideo,
              hotelVideoPhoto,
              hotelId
              od_Video
              sOtel_Konum
            }
            prices {
              turf_Price
              turf_MaxPrice
              turf_RoomType
              turf_MaxAge
              turf_MinAge
              pax{
                tr
                en
              }
              room{
                tr
                en
              }
            }
            routes {
              turs_Date
              rDayName
              turs_Transporter
              turs_CityEnd {
                tr
                en
              }
              turs_CityStart {
                tr
                en
              }
              rYear
              rDay
              rMonth
              turs_FlightNo
              turs_transDetail {
                tr
                en
              } 
              turs_Time
              flight_kuyruk_no
              source_time
            }
        }
      }
    `;

    const config = useRuntimeConfig();
    return new Promise((resolve, reject) => {
      axios({
        url: `${config.public.apiBase}`+"/graphql/direct",
        method: 'post',
        data: {
          query: q
        }
      }).then(response => {
     
        let item = response.data.data.tour[0];
 
        if (item && item.prices) {
          item.prices =  item.prices;
        }else
        if (item && item.turs_double) {
          item.prices = [
            { pax: { tr: "Yetişkin", en: "Adult" }, room: { tr: "İkili Oda",en: "Double Room" }, turf_Price: item.turs_double, turf_PriceHigh: item.turs_double_high,  turf_RoomType: "dFJvb21zMTUzMzUwMDc4Mgqq" },
            { pax: { tr: "Yetişkin", en: "Adult" }, room: { tr: "Üçlü Oda",en: "Triple Room"  }, turf_Price: item.turs_triple, turf_PriceHigh: item.turs_triple_high, turf_RoomType: "dFJvb21zMTUzMzUwMDgwNwqq" },
            { pax: { tr: "Yetişkin", en: "Adult" }, room: { tr: "Tekli Oda",en: "Single Room"  }, turf_Price: item.turs_single, turf_PriceHigh: item.turs_single_high, turf_RoomType: "dFJvb21zMTUzMzUwMDgyNgqq" },
            { pax: { tr: "Çocuk", en: "Child" }, room: { tr: "", en: "" }, turf_Price: item.turs_child, turf_PriceHigh: item.turs_child_high, turf_RoomType: "dFJvb21zMTUzMzUwMDc4Mgqq" },
            { pax: { tr: "Bebek", en: "Baby" }, room: { tr: "", en: "" }, turf_Price: item.turs_baby, turf_PriceHigh: item.turs_baby_high, turf_RoomType: "dFJvb21zMTUzMzUwMDc4Mgqq" }
          ]
        }

        if(item && item.turs_price_info){ 
          item.turs_price_info = decodeHTMLEntities(item.turs_price_info).replaceAll("<p>", '<p style="font-size:14px; line-height: 20px; margin:0">');
        }
        if(item && item.categories){
          item.PUPULARGUIDES = item.categories.includes("PUPULARGUIDES") ? true : false;
        }
    
        if (item && item.otel1_adi && typeof item.otel1_adi == "object" && item.otel1_adi.tr && item.otel1_photo) {

          let gallery1 = null;
          let gallery2 = null;
          let hotelId1 = null;
          let hotelId2 = null;

          if (item.hotels && item.hotels[0]) {
            gallery1 = item.hotels[0].hPhotoGallery;
            hotelId1 = item.hotels[0].hotelId;
          }

          if (item.hotels && item.hotels[1]) {
            gallery2 = item.hotels[1].hPhotoGallery;
            hotelId2 = item.hotels[1].hotelId;
          }

          item.hotels = [
            { turo_Sure: item.turs_otel1_sure, hPhotoGallery: gallery1, city: item.hotels?.[0]?.city || { tr: "Medine", en: "Medina" }, sOtelAdi: item.otel1_adi, hotelId: hotelId1,  hotelVideo: item.otel1_video, hotelVideoPhoto:item.otel1_video_photo,  sOtelPhoto: item.otel1_photo, star: item.otel1_star || { tr: "5 Yıldız" } },
          ]
          if(item.turs_otel2_sure && item.hotels && item.hotels.length >0){
              item.hotels.push({ turo_Sure: item.turs_otel2_sure, hPhotoGallery: gallery2, city: item.hotels?.[1]?.city || { tr: "Mekke", en: "Makkah" }, sOtelAdi: item.otel2_adi, hotelId: hotelId2,  hotelVideo: item.otel2_video, hotelVideoPhoto:item.otel2_video_photo,  sOtelPhoto: item.otel2_photo, star: item.otel2_star || { tr: "5 Yıldız" } })
          }

        }
        
        if(item && item.cityDuration && typeof item.cityDuration == "string"){
          item.cityDuration = item.cityDuration.replaceAll("&quot;","\"");
          item.cityDuration = JSON.parse(item.cityDuration)
        }
        resolve(item)

      }).catch(e => {
        console.log(e)
        reject(e)
      })
    });
  }

  const isJsonString = (str) => {
    if (str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    } else {
        return false
    }
}; 


const formatDate = (date,formatValue,locale="tr")=>{
  const datex = new Date(date); 
  const formatString = formatValue || 'yyyy-MM-dd'; 
  if(locale=="tr"){
    return format(datex, formatString, { locale: tr });
  }else{
    return format(datex, formatString);
  }
  
};

  const getTour = (payload, locale="all",lang="tr") => {
  
 
  const config = useRuntimeConfig();
  return new Promise((resolve, reject) => { 


  const headers = useHeader()?.value; 
  let id = payload.id;
   
 
      axios({ 
        url: `${config.public.apiBase}`+"/rest/TourDates",
        params: {
          limit: 1,
          offset:0,
          lang: locale,
          filter:JSON.stringify({id:["=",id], status: ["!=","4"]}),
          sort: ['id,DESC'],
          // fields: 'id,created_on,status,created_by,turs_title,turs_program,turs_price_info,turs_StartDate,turs_EndDate,turf_Airway,tur_Sure,tour_Currency,turs_double,turs_single,turs_triple,turs_child,turs_baby,turd_Short,turs_otel1,turs_otel2,turs_otel1_sure,turs_otel2_sure,next_TourHotels.id turh_id(id) turh_duration turh_board tourh_checkin tourh_checkout tourh_room,next_turTransportation.id turs_Date pdb_sira turs_Transporter turs_transDetail turs_CityStart turs_CityEnd'
          fields: `id,turs_pdf,turs_StartDate,turs_EndDate,tur_Sure,turMainPhoto,turf_Airway(id,ai_logo,airway_name)
          ,turs_Detail(id,turd_Detail,turd_PriceInfo,turd_Video,turd_Visa,turd_Name,turd_Galeri,turd_Highlight,turd_Icons)
          ,turs_Cat,turs_Kota,turs_SubCat,turd_TopImage,turs_destination,turs_Video,turs_status,turs_program,turs_VideoPhoto,turs_voice_text,turs_voice_video,turs_show_video_or_sound,turs_voice_file,turs_gallery,turs_photo_gallery,turs_cities,turs_price_info,turs_title,turd_Color,colorful_title,turs_CampaignTitle,turf_Airway,tour_Currency,turd_Short,tour_Currency,turs_double,turs_single,turs_triple,turs_child,turs_baby,turd_Short
          ,next_TourHotels(id,turh_duration,tourh_checkin,tourh_checkout,pdb_sira,turh_id(id,sOtelAdi,sOtelShort,sOtel_Konum,sOtelPhoto,h_hotelCity(id,cityName),sOtelStars(id,hS_Name),hotelLink,hPhotoGallery,hotelVideo,hotelVideoPhoto)
          ,turh_duration,turh_board,tourh_checkin,tourh_checkout,tourh_room)
          ,next_turTransportation(id,turs_Date,pdb_sira,turs_Transporter,turs_transDetail,turs_FlightNo,turs_Time,turs_CityStart(id,cityName),turs_CityEnd(id,cityName))
          ,next_TourPrices(id,turf_RoomType,turf_PaxType,turf_Price,turf_MinAge,turf_MaxAge,turf_MaxPrice)
          ,next_TourGuides(id,sort,turs_guide_description,turs_guide(id,U_rname,U_surname,U_Photo,U_Role))
          `
        },
        method: "get",
        origin: true,
        withCredentials: true,
        headers 
      })
        .then(response => {  
          let item = response.data.formattedData[0];
          // console.log("response.item",item)
          item.start = formatDate(item.turs_StartDate, "dd MMM yyyy");
          item.end = formatDate(item.turs_EndDate, "dd MMM yyyy");
          item.pdb_Id = (item.id);
          item.airwayLogo = (item.id);
          item.airwayLogo = item.from_turf_Airway?.ai_logo;
          item.airwayName = item.from_turf_Airway?.airway_name;
          item.detail = item.from_turs_Detail;
          item.categories = [];
          if(item.turs_Cat){
            item.categories.push(item.turs_Cat);
          }
          if(item.turs_SubCat){
            let cats = item.turs_SubCat.split("---");
            cats.forEach(cat=>{
              item.categories.push(cat);
            })
          }
          
          const start = parseISO(item.turs_StartDate)
          const end = parseISO(item.turs_EndDate)
        
          const allDates = eachDayOfInterval({ start, end }).map(date =>
            formatDate(date, 'dd MMMM, eeee ') // or any format you need
          )
           
          if(item.turs_program){
               let program =  decodeHTMLEntities(item.turs_program);  
                program =  program.replaceAll("<p", '<p style="font-size:.9rem; line-height: 1.5; margin:0" ') ;
                program =  program.replaceAll("<li", '<li style="font-size:.9rem; line-height: 1.5; margin:0" ') ;
                program =  program.replaceAll("<ul class=\"", '<ul class=\"list-disc ml-3 pl-3 my-1 ') ;
                program =  program.replaceAll("<hr", '<hr class="my-3 bg-white" ') ;
                allDates.forEach((date,i)=>{
                  program = program ? program.replaceAll(`[DATE${i+1}]`, `${date}`) : '';
                }) 
                item.turs_program = program;
          }
           if(item.turs_price_info){
               let program =  decodeHTMLEntities(item.turs_price_info);  
                program =  program.replaceAll("<p", '<p style="font-size:.9rem; line-height: 1.5; margin:0" ') ;
                program =  program.replaceAll("<li", '<li style="font-size:.9rem; line-height: 1.5; margin:0" ') ;
                program =  program.replaceAll("<ul class=\"", '<ul class=\"list-disc ml-3 pl-3 my-1 ') ;
                program =  program.replaceAll("<hr", '<hr class="my-3 bg-white" ') ;
                allDates.forEach((date,i)=>{
                  program = program ? program.replaceAll(`[DATE${i+1}]`, `${date}`) : '';
                }) 
                item.turs_price_info = program;
          }

          if(item.detail && item.detail.turd_PriceInfo){
           
            Object.keys(item.detail.turd_PriceInfo).forEach((lang)=>{
              let itemx = item.detail.turd_PriceInfo[lang]; 
              itemx =  decodeHTMLEntities(itemx);
              itemx = itemx ? itemx.replaceAll("<p ", '<p style="font-size:.9rem; line-height: 1.5; margin:0" ') : '';
              itemx = itemx ? itemx.replaceAll("<li", '<li style="font-size:.9rem; line-height: 1.5; margin:0" ') : '';
              itemx = itemx ? itemx.replaceAll("<ul class=\"", '<ul class=\"list-disc ml-3 pl-3 my-1 ') : '';
              itemx = itemx ? itemx.replaceAll("<hr", '<hr class="my-3 bg-white" ') : '';
              allDates.forEach((date,i)=>{
                itemx = itemx ? itemx.replaceAll(`[DATE${i+1}]`, `${date}`) : '';
              })
              item.detail.turd_PriceInfo[lang] = itemx;
            }) 
          }


          if(item.detail && item.detail.turd_Detail){
           
            Object.keys(item.detail.turd_Detail).forEach((lang)=>{
              let itemx = item.detail.turd_Detail[lang];
            
              if(itemx){
                itemx =  decodeHTMLEntities(itemx);  
                itemx =  itemx.replaceAll("<p", '<p style="font-size:.9rem; line-height: 1.5; margin:0" ') ;
                itemx =  itemx.replaceAll("<li", '<li style="font-size:.9rem; line-height: 1.5; margin:0" ') ;
                itemx =  itemx.replaceAll("<ul class=\"", '<ul class=\"list-disc ml-3 pl-3 my-1 ') ;
                itemx =  itemx.replaceAll("<hr", '<hr class="my-3 bg-white" ') ;
                allDates.forEach((date,i)=>{
                  itemx = itemx ? itemx.replaceAll(`[DATE${i+1}]`, `${date}`) : '';
                }) 
                item.detail.turd_Detail[lang] = itemx;
              }
            }) 
          } 
          item.next_TourHotels = item.next_TourHotels?.sort((a, b) => {
            return a.pdb_sira - b.pdb_sira;
          });

          item.guides = (item.next_TourGuides || [])
            .filter((row) => row?.from_turs_guide?.U_Role === 'Guide')
            .sort((a, b) => Number(a?.sort || 0) - Number(b?.sort || 0))
            .map((row) => {
              const guide = row.from_turs_guide;
              return {
                id: guide.id || row.id,
                name: [guide.U_rname, guide.U_surname].filter(Boolean).join(' ').trim(),
                photo: guide.U_Photo || '',
                description: row.turs_guide_description || ''
              };
            })
            .filter((guide) => guide.name);

          item.hotels =  item.next_TourHotels && item.next_TourHotels.length > 0  ? item.next_TourHotels.map(item => {

            if(item.from_turh_id){
 
                item.sOtelAdi = item.from_turh_id.sOtelAdi;
                item.sOtelPhoto = item.from_turh_id.sOtelPhoto;
                item.hotelId = item.from_turh_id.id;
                item.city = getCityName(item.from_turh_id.h_hotelCity);
                item.sOtelStars = item.from_turh_id.sOtelStars;
                item.star = getStarName(item.from_turh_id.sOtelStars);
                item.hPhotoGallery = item.from_turh_id.hPhotoGallery;  
                item.hotelVideo = item.from_turh_id.hotelVideo;
                item.sOtelShort = item.from_turh_id.sOtelShort;
                item.hotelVideoPhoto = item.from_turh_id.hotelVideoPhoto;
              }
              item.h_hotelCity = getCityName(item.h_hotelCity) ;
              item.turo_Sure = item.turh_duration;
            return item;
          }) : []
         
        
          item.routes = item.next_turTransportation.map(item => {

              
            item.rDayName = formatDate(item.turs_Date, "EEEE",lang);
            item.rYear = formatDate(item.turs_Date, "yyyy",lang);
            item.turs_Transporter = icons[item.turs_Transporter] || item.turs_Transporter;
            item.rDay = formatDate(item.turs_Date, "dd",lang);
            item.rMonth = formatDate(item.turs_Date, "MMM",lang);
            item.turs_Date = formatDate(item.turs_Date,null,lang);
            item.turs_CityStart_Name = getCityName(item.turs_CityStart)
            item.turs_CityEnd_Name = getCityName(item.turs_CityEnd) ;

            return item;  

          }).sort((a, b) => {
            return a.pdb_sira - b.pdb_sira;
          });

          if(item && item.categories){
            item.PUPULARGUIDES = item.categories.includes("PUPULARGUIDES") ? true : false;
          }

         
          item.prices = item.next_TourPrices.map(pricex => {
            
            let room = roomTypes.find(itemx => itemx.id == pricex.turf_RoomType);
            if(pricex.turf_PaxType=="turAdult"){ 
              pricex.sort = room?.sort || 10;
            }else if(pricex.turf_PaxType=="turChild"){ 
              pricex.sort = 100;
            }else if(pricex.turf_PaxType=="turChildNoBed"){ 
              pricex.sort = 150;
            }else if(pricex.turf_PaxType=="turBaby"){ 
              pricex.sort = 200;
            }
            pricex.room = room?.name || "";
            pricex.turf_PriceHigh = pricex.turf_MaxPrice * 1;
            pricex.turf_Price= pricex.turf_Price * 1;
        
            return pricex;
          }).sort((a, b) => {
            return a.sort - b.sort;
          });
        
          item.turs_status_data =  tourStatuses.find(itemx=> itemx.value == item.turs_status) || tourStatuses[0];
        
  
      
          if(item.turs_cities){
            item.turs_cities = decodeHTMLEntities(item.turs_cities)
          }
          if(item.turs_cities && isJsonString(item.turs_cities)){ 
            item.cityDuration = JSON.parse(item.turs_cities);
          }else{
            item.cityDuration = (item.turs_cities);
          }

        //  console.log("item",item)
          resolve(item)
      }).catch(e => {
        console.log(e)
        reject(e)
      });
 

  })
 return;
 
  }
  return {
    getTours,
    getTour,
    getTourDetail

  }


}
